<template>
    <transition name="fade">
        <div class="global-mask" v-show="gameOver || gameWin || !isPlaying">
            <span class="start" v-if="!isPlaying">点击左边按钮开始游戏</span>
            <span class="lose animated tada" v-else-if="gameOver">Ops~踩到雷啦！</span>
            <span class="win animated jackInTheBox" v-else-if="gameWin">不错呦~YOU WIN!</span>
        </div>
    </transition>
</template>
<script>
export default {
    name: 'MatrixMask',
    computed: {
        gameOver () {
            return this.$store.state.gameOver
        },
        gameWin () {
            return this.$store.state.gameWin
        },
        isPlaying () {
            return this.gameOver || this.gameWin || this.$store.state.isPlaying  
        }
    }
}
</script>
<style lang="scss" scoped>
.global-mask {
    position: absolute;
    top:0;left:0;
    display: flex;
    justify-content: center;
    align-items: center;
    width:100%;
    height:100%;
    z-index:2;
    background:rgba(0,0,0,.2);
    border-radius: 12px;
    user-select: none;

    span {
        font-size:2rem;
        text-shadow: 0 5px 10px rgba(0,0,0,.5);

        &.start {
            color:rgb(221, 255, 230);
            animation: upDown 1s linear infinite;
        }

        &.lose {
            color: rgb(228, 56, 127);
            font-size:4rem;
        }

        &.win {
            color: rgb(28, 245, 126);
            font-size:4rem;
        }

    }

    @keyframes upDown {
        0% { transform: translateX(0px) }
        50% { transform: translateX(10px) }
        100% { transform: translateX(0px) }
    }

}
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>